module.exports = __webpack_public_path__ + "img/Gala_2024.52897b14.png";